<template>
	<v-container fluid grid-list-lg class="pa-3">
		<transition>
			<v-layout row align-start justify-end v-if="fpes_status.length > 0 ? fpes_status[0]._id == selected.status_id : false">
				<v-flex xs12 sm6 md5 lg3>
					<v-card>
						<v-container class="pa-3">
							<v-layout>
								<v-flex class="display-3 text-xs-center pa-0">{{
				emp_info.total_count
			}}</v-flex>
							</v-layout>
							<v-layout>
								<v-flex class="text-xs-center">
									Total active employees <br />
									{{ epoch2date(emp_info.current_epoch) }}
								</v-flex>
							</v-layout>
						</v-container>
					</v-card>
				</v-flex>
			</v-layout>
		</transition>

		<v-layout row wrap>
			<v-flex class="pt-0">
				<v-tabs v-model="tabs.active" dark slider-color="secondary" color="warning">
					<v-tab ripple>
						Basic Info
					</v-tab>
					<v-tab ripple>
						Listing
					</v-tab>

					<v-tab-item>
						<v-card flat color="dull">
							<v-card-text>
								<v-form ref="MainForm" lazy-validation v-model="form_valid">
									<v-container fluid class="pa-0">
										<v-layout row wrap>
											<v-flex xs12 sm10>
												<v-text-field label="Label (required)" hint="Short description" maxlength="50" v-model="selected.report_label" :rules="[rules.required]" counter></v-text-field>
											</v-flex>

											<v-flex xs12 sm2>
												<v-select :items="fpes_status" readonly v-model="selected.status_id" item-text="label" item-value="_id" label="Status">
												</v-select>
											</v-flex>
										</v-layout>

										<v-layout>
											<v-flex>
												<v-textarea label="Description" hint="Full description about this report" maxlength="200" v-model="selected.description" counter></v-textarea>
											</v-flex>
										</v-layout>

										<v-layout row wrap>
											<v-flex xs12 sm6 md3>
												<v-menu v-model="start_menu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">

													<template v-slot:activator="{ on }">
														<v-text-field v-model="selected.start_date" label="Start Date (required)" hint="Start date in YYYY-MM-DD format" persistent-hint readonly prepend-icon="event" v-on="on"></v-text-field>
													</template>
													<v-date-picker v-model="selected.start_date" no-title @input="start_menu = false"></v-date-picker>
												</v-menu>
											</v-flex>

											<v-flex xs12 sm6 md3>
												<v-menu v-model="end_menu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">

													<template v-slot:activator="{ on }">
														<v-text-field v-model="selected.end_date" label="End Date (required)" hint="End date in YYYY-MM-DD format" persistent-hint readonly prepend-icon="event" v-on="on"></v-text-field>
													</template>
													<v-date-picker v-model="selected.end_date" no-title @input="end_menu = false"></v-date-picker>
												</v-menu>
											</v-flex>

											<v-flex xs12 sm6 md3>
												<v-menu v-model="import_start_menu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">

													<template v-slot:activator="{ on }">
														<v-text-field v-model="selected.import_start_date" label="Import Start Date (required)" hint="Start date in YYYY-MM-DD format" persistent-hint readonly prepend-icon="event" v-on="on"></v-text-field>
													</template>
													<v-date-picker v-model="selected.import_start_date" no-title @input="import_start_menu = false"></v-date-picker>
												</v-menu>
											</v-flex>

											<v-flex xs12 sm6 md3>
												<v-menu v-model="import_end_menu" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">

													<template v-slot:activator="{ on }">
														<v-text-field v-model="selected.import_end_date" label="Import End Date (required)" hint="End date in YYYY-MM-DD format" persistent-hint readonly prepend-icon="event" v-on="on"></v-text-field>
													</template>
													<v-date-picker v-model="selected.import_end_date" no-title @input="import_end_menu = false"></v-date-picker>
												</v-menu>
											</v-flex>
										</v-layout>

										<v-layout row wrap>
											<v-flex xs12 sm6 md3>
												<v-text-field v-model.number="selected.top_rate" type="number" prepend-icon="thumb_up_alt" :rules="[rules.required, rules.greater_than_zero]" label="Top class percentage (required)"></v-text-field>
											</v-flex>

											<v-flex xs12 sm6 md3>
												<v-text-field v-model.number="selected.bottom_rate" type="number" prepend-icon="thumb_down_alt" :rules="[rules.required, rules.greater_than_zero]" label="Bottom class percentage (required)"></v-text-field>
											</v-flex>
											<v-flex xs12 sm6 md3>
												<v-text-field v-model="selected.created_by" label="Created by" hint="Created date/time:" :messages="epoch2date(selected.created)" readonly></v-text-field>
											</v-flex>
											<v-flex xs12 sm6 md3>
												<v-text-field readonly :messages="epoch2date(selected.modified)" v-model="selected.modified_by" hint="Last modified date/time:" label="Last modified by"></v-text-field>
											</v-flex>
										</v-layout>

										<v-layout row wrap>
											<v-flex xs12 class="text-sm-right pa-0">
												<v-btn color="dull" :block="$vuetify.breakpoint.xsOnly" href="/FPES-Report-Listing?uuid=7219463c-f3fe-4d2e-a6ea-f773e2a9b960">
													<v-icon left>cancel</v-icon>Cancel
												</v-btn>

												<v-btn color="dull" v-if="selected._id" :block="$vuetify.breakpoint.xsOnly" @click="recalculate">
													<v-icon left>calculate</v-icon>Calculate
												</v-btn>

												<v-btn color="dull" v-if="selected._id" :block="$vuetify.breakpoint.xsOnly" @click="populate_fpes_entries">
													<v-icon left>flag</v-icon>Populate
												</v-btn>
												<v-btn :block="$vuetify.breakpoint.xsOnly" @click="save_onclick" color="primary">
													<v-icon left>save</v-icon>Save
												</v-btn>
											</v-flex>
										</v-layout>
									</v-container>
								</v-form>
							</v-card-text>
						</v-card>
					</v-tab-item>

					<v-tab-item>
						<v-container fluid class="'dull'">
							<v-layout row wrap>
								<v-flex xs12 sm4>
									<v-text-field label="Filter Full Name:"
										v-model="table.filter_by_name"
										placeholder="Fitcorper Full Name"
										clearable
										@keydown.enter="reload_fpes_report_entries"
										@click:clear="filter_onclear">
									</v-text-field>
								</v-flex>
								<v-flex xs12 sm4>
									<v-text-field label="Filter Userame:"
										v-model="table.filter_by_username"
										placeholder="Fitcorper Username"
										clearable
										@keydown.enter="reload_fpes_report_entries"
										@click:clear="filter_onclear">
									</v-text-field>
								</v-flex>
								<v-flex xs12 sm4>
									<v-text-field label="Filter by Company or Dept:"
										v-model="table.filter_by_company_dept"
										placeholder="Filter by Company or Dept"
										clearable
										@keydown.enter="reload_fpes_report_entries"
										@click:clear="filter_onclear">
									</v-text-field>
								</v-flex>
							</v-layout>
						</v-container>

						<v-data-table dark :pagination.sync="table.pagination" :total-items="table.total_items" :headers="table.headers.filter((r) => r.viewable == true)" :loading="table.loading" :rows-per-page-items="table.rows_per_page_items" :items="table.items">

							<template v-slot:items="props">
								<td class="px-0">
									<v-menu bottom right>
										<template v-slot:activator="{ on }">
											<v-btn small icon v-on="on">
												<v-icon color="deep-purple accent-1">more_vert</v-icon>
											</v-btn>
										</template>

										<v-list dense class="pa-0">
											<v-list-tile :href="'Update-Fpes-Report-Entries?uuid=3c974a6e-feab-4c7c-a4a1-55669d1ce018&_id=' + props.item._id">
												<v-list-tile-action>
													<v-icon>edit</v-icon>
												</v-list-tile-action>
												<v-list-tile-title>Edit</v-list-tile-title>
											</v-list-tile>
											<v-list-tile :href="'/Submit-Evidence-Crud/?uuid=dc0931b5-f388-421d-85ac-01024faa9160&_id=' + props.item._id" target="_blank">
												<v-list-tile-action>
													<v-icon>preview</v-icon>
												</v-list-tile-action>
												<v-list-tile-title>Review</v-list-tile-title>
											</v-list-tile>
										</v-list>
									</v-menu>
								</td>
								<td>{{ epoch2date(props.item.modified) }}</td>
								<td>{{ props.item.modified_by }}</td>
								<td><b>{{ props.item.username }}</b></td>
								<td>{{ props.item.full_name }}</td>
								<td v-html="display_company_dept(props.item.company_dept)"></td>
								<td v-html="populate_appraisal_list_items(props.item.appraisals)"></td>
								<td>{{ props.item.score }}</td>
								<td>{{ props.item.eul }}</td>
								<td>{{ props.item.lateness }}</td>
								<td>{{ props.item.mc }}</td>
								<td>{{ props.item.remark }}</td>
								<td>{{ props.item.rank }}</td>
								<td>{{ props.item.validity }}</td>
								<td>{{ props.item.ack_status }}</td>
								<td>{{ props.item.ack_type }}</td>
							</template>
						</v-data-table>
					</v-tab-item>
				</v-tabs>

			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import query_builder from "../../functions/query.builder";
import general from "../../functions/general";

export default {
	name: "FPES-Report",
	data() {
		return {
			emp_info: {
				total_count: 0,
				current_epoch: 0,
			},
			tabs: {
				active: 0
			},
			start_menu: false,
			end_menu: false,
			import_start_menu: false,
			import_end_menu: false,
			form_valid: true,
			rules: {
				required: (value) => !!value || "This field required.",
				greater_than_zero: (value) => value > 0 || "Value must greater than 0.",
			},
			fpes_status: [],
			selected: {
				_id: "",
				created: "",
				created_by: "",
				modified: "",
				modified_by: "",
				start_date: "",
				end_date: "",
				import_start_date: "",
				import_end_date: "",
				status_id: "",
				total_emps: 0,
				top_rate: 60,
				bottom_rate: 10,
				report_label: "",
				description: "",
			},
			table: {
				headers: [
					{
						text: "",
						value: "",
						align: "left",
						sortable: false,
						viewable: true,
						type: "Number",
						class: "px-0",
						width: "30px",
					},
					{
						text: "ID",
						value: "_id",
						align: "left",
						sortable: false,
						viewable: false,
						type: "Number",
						class: "",
						width: "",
					},
					{
						text: "Modified",
						value: "modified",
						align: "left",
						sortable: true,
						viewable: true,
						type: "DateTime",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Modified By",
						value: "modified_by",
						align: "left",
						type: "String",
						sortable: true,
						viewable: true,
						class: "font-weight-black",
						width: "",
					},
					{
						text: "User Name",
						value: "username",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Full Name",
						value: "full_name",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Comapany : Dept",
						value: "company_dept",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Appraisal",
						value: "appraisals",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Score",
						value: "score",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "EUL",
						value: "eul",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Lateness",
						value: "lateness",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "MC",
						value: "mc",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Remark",
						value: "remark",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Rank",
						value: "rank",
						align: "left",
						type: "String",
						sortable: true,
						viewable: true,
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Validity",
						value: "validity",
						align: "left",
						type: "String",
						sortable: true,
						viewable: true,
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Ack Status",
						value: "ack_status",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Ack Type",
						value: "ack_type",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
				],
				items: [],
				loading: false,
				total_items: 0,
				filter_by_name:"",
				filter_by_username:"",
				filter_by_company_dept:"",
				rows_per_page_items: [25, 50, 100, 200, 1000],
				pagination: {
					descending: true,
					page: 1,
					rowsPerPage: 1000,
					sortBy: "score",
					totalItems: 100,
				},
			},
		};
	},
	computed: {},
	watch: {
		"table.pagination": {
			handler: function () {
				this.reload_fpes_report_entries();
			},
			deep: true,
		},
	},
	methods: {
		filter_onclear(){
			this.$nextTick(()=>{
				this.reload_fpes_report_entries();
			});
		},
		display_company_dept(value) {
			let ret = "";
			let list = value.split(",");

			if (list.length > 0) {
				ret = "<ul><li>";

				ret += list.join("</li><li>");
				ret += "</li></ul>";
			}

			return ret;
		},
		populate_appraisal_list_items(arr) {
			let superior = [], self = [], peer = [];

			for (var i = 0, m = arr.length; i < m; i++) {
				let el = arr[i];

				if (el.type.includes("Superior")) {
					superior.push(el.ave_score);
				} else if (el.type.includes("Self")) {
					self.push(el.ave_score);
				} else if (el.type.includes("Peer")) {
					peer.push(el.ave_score);
				}
			}

			let html_text = `
			<ul class="font-weight-light">
				<li>Superior : [${superior.join("] [")}]</li>
				<li>Self : [${self.join("] [")}]</li>
				<li>Peer : [${peer.join("] [")}]</li>
			</ul>
			`;

			return html_text;
		},
		epoch2date: general.App.epoch2LocaleDatetime,
		async populate_fpes_entries() {
			general.App.loader.show(this);

			let post_data = this.selected;

			let url = "fpes/fpes_report_entries/";
			var result = await general.wBackEndComm.PostData(url, post_data);
			result = result.data;

			if (result.Status == 1) {
				this.selected.status_id = result.Body.fpes_report_status_id;
				this.selected.modified = result.Body.modified;
				this.selected.modified_by = result.Body.modified_by;
				this.selected._rev = result.Body._rev;

				general.wMsgBox.Success(result.Description);
				this.reload_fpes_report_entries();
			} else {
				general.wMsgBox.Error(result.Description);
			}

			general.App.loader.hide(this);
		},
		async recalculate() {
			general.App.loader.show(this);

			let url = "fpes/calculate_others_factor_data/?id=" + this.selected._id;
			var result = await general.wBackEndComm.GetData(url);
			result = result.data;

			if (result.Status == 1) {
				this.reload_fpes_report_entries();
				general.wMsgBox.Success(result.Description);
			} else {
				general.wMsgBox.Error(result.Description);
			}

			general.App.loader.hide(this);
		},
		async reload_fpes_report_entries() {
			if (!this.selected._id) {
				return;
			}
			var qb = new query_builder.QueryBuilder();

			qb.Table = "fpes_report_entries_view";

			var rule = new query_builder.Rule();
			rule
				.field("fpes_report_id")
				.operator(query_builder.A_STR_OPERATOR.EQUAL)
				.value(this.selected._id);
			qb.Where.rules.push(rule);

			if(this.table.filter_by_name!=null && this.table.filter_by_name.length > 0){
				rule = new query_builder.Rule();

				rule
					.field("full_name")
					.operator(query_builder.A_STR_OPERATOR.I_CONTAINS)
					.value(this.table.filter_by_name);
				qb.Where.rules.push(rule);
			}

			if(this.table.filter_by_username!=null && this.table.filter_by_username.length > 0){
				rule = new query_builder.Rule();

				rule
					.field("username")
					.operator(query_builder.A_STR_OPERATOR.I_CONTAINS)
					.value(this.table.filter_by_username);
				qb.Where.rules.push(rule);
			}

			if(this.table.filter_by_company_dept!=null && this.table.filter_by_company_dept.length > 0){
				rule = new query_builder.Rule();

				rule
					.field("company_dept")
					.operator(query_builder.A_STR_OPERATOR.I_CONTAINS)
					.value(this.table.filter_by_company_dept);
				qb.Where.rules.push(rule);
			}

			qb.Limit = this.table.pagination.rowsPerPage;
			qb.Offset = this.table.pagination.page;

			if (this.table.pagination.sortBy) {
				qb.Order = [
					{
						name: this.table.pagination.sortBy,
						descending: this.table.pagination.descending,
					}
				];
			}

			var res = await general.wBackEndComm.PostData("process_arango_qb/", qb);
			res = res.data;
			if (res.Status == 1) {
				var all_records = res.Body[0].records;

				this.table.items = all_records;
				this.table.total_items = res.Body[0].total_records;

				// if(this.table.filter_by_name!=null && this.table.filter_by_name.length > 0){
				// 	var reg = new RegExp(this.table.filter_by_name,"gi");

				// 	var temp_filtered = all_records.filter(el=>{
				// 		if(reg.test(el.username) || reg.test(el.full_name)){
				// 			return true;
				// 		}
				// 		return false;
				// 	});

				// 	this.table.items = temp_filtered;
				// 	this.table.total_items = temp_filtered.length;

				// }else {
				// 	this.table.items = all_records;
				// 	this.table.total_items = res.Body[0].total_records;
				// }
			} else {
				general.wMsgBox.Error(res.Description);
			}
		},
		async save_onclick() {
			general.App.loader.show(this);

			if (this.$refs.MainForm.validate()) {
				var new_rec = !this.selected._id;
				var url = "fpes/report_crud/";

				var result = await general.wBackEndComm.PostData(url, this.selected);
				result = result.data;

				if (result.Status == 1) {
					this.selected = result.Body;
					if (new_rec) {
						window.history.pushState({}, null, "/FPES-report?uuid=11c6e519-a679-4c24-89c9-c57cb3b94645&_id=" + this.selected._id);
					}
					general.wMsgBox.Success(result.Description);
				} else {
					general.wMsgBox.Error(result.Description);
				}
			} else {
				general.wMsgBox.Error(
					"Please fill in all required fields before click on save button."
				);
			}
			general.App.loader.hide(this);
		},
	},
	async mounted() {
		general.App.loader.show(this);
		general.App.set_page_title("mySuite : FPES Report Crud");

		this.fpes_status = await general.App.arango_app_selections("fpes_report", "status");

		var url = "employees/get_count_active_emp/";
		var result = await general.wBackEndComm.GetData(url);
		result = result.data;

		if (result.Status == 1) {
			this.emp_info = result.Body;
		} else {
			//
		}

		this.selected._id = general.App.getQueryString("_id");

		// initialize
		if (!this.selected._id) {
			if (this.fpes_status.length > 0) {
				this.selected.status_id = this.fpes_status[0]["_id"];
			}

			let today = new Date();
			this.selected.start_date = today.toISOString().substring(0, 10);
			this.selected.end_date = new Date(today.setMonth(today.getMonth() + 3))
				.toISOString()
				.substring(0, 10);
			this.selected.import_start_date = today.toISOString().substring(0, 10);
			this.selected.import_end_date = new Date(today.setMonth(today.getMonth() + 3))
				.toISOString()
				.substring(0, 10);
		} else {
			let url1 = "fpes/report_crud/?_id=" + this.selected._id;

			let result1 = await general.wBackEndComm.GetData(url1);
			result1 = result1.data;

			if (result1.Status == 1) {
				this.selected = result1.Body;

				if (this.selected.status_id == this.fpes_status[1]._id) {
					this.tabs.active = 1;
					this.reload_fpes_report_entries();
				}
			} else {
				general.wMsgBox.Error(result1.Description);
			}
		}

		general.App.loader.hide(this);
	},
};
</script>

<style scoped></style>
